<template>
  <div class="content">
    <sub-title>슬롯</sub-title>
    <div class="casinoslot_panel">
      <money-chip-change-comp></money-chip-change-comp>
      <div class="items">
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'evo_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/evo_slot.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'pragmatic_slot'}}">
          <div class="pic"  alt="">
            <img src="../../../assets/images/casino/s/pragmatic-n.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'habanero_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/habanero_slot.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'cq9_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/cq9_slot.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'relax_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/relax_slot.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'booongo_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/booongo_slot.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'playson_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/playson_slot.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'ygg_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/ygg_slot.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'dragoonsoft_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/dragoonsoft_slot.png" alt="">
          </div>
        </router-link>
        <router-link class="itm" tag="div"  :to="{path: '/front/slotlist', query: {slotcode: 'octoplay_slot'}}">
          <div class="pic">
            <img src="../../../assets/images/casino/s/octoplay_slot.png" alt="">
          </div>
        </router-link>

      </div>
    </div>

    <my-unchecked-message-comp></my-unchecked-message-comp>
  </div>

</template>


<script>

    import {RECEIVE_HIDE_LOADING, RECEIVE_SHOW_LOADING} from "@/store/mutation-types";
    import {casinoMixin, casinoNextZoneMixin, checkLoginOnCreateMinxin, postionMixin} from "@/common/mixin";
    import SubTitle from "@/views/afront/zero/SubTitle.vue";
    import MoneyChipChangeComp from "@/views/afront/casino/MoneyChipChangeComp.vue";
    import MyUncheckedMessageComp from "@/views/afront/notice/MyUncheckedMessageComp.vue";
    export default {
      name: "SlotHonor",
      mixins: [postionMixin,casinoNextZoneMixin,checkLoginOnCreateMinxin],
      components: {
        MyUncheckedMessageComp,
        MoneyChipChangeComp,
        SubTitle

      },
      data() {
        return {
          position: "슬롯",
        }
      },
      methods: {

      },
      created() {
      },
    }
</script>

<style scoped>
    @import url("../../../assets/css/front/afrontcasinoslot.css");
</style>